import { createReducer, isAnyOf } from "@reduxjs/toolkit";
import { createSession, createSessionFailure, createSessionSuccessful, removeSession, removeSessionFailure, removeSessionSuccessful, setSession, setState, setUploadingMetadata, setUploadingTimeSeries, uploadTimeSeries, uploadMetadata, deleteTimeSeriesFile, deleteMetadataFile, createProcessDataFromBatch, uploadTimeSeriesSuccessful, uploadTimeSeriesFailure, uploadMetadataSuccessful, uploadMetadataFailure, deleteTimeSeriesFileSuccessful, deleteTimeSeriesFileFailure, deleteMetadataFileSuccessful, deleteMetadataFileFailure, createProcessDataFromBatchSuccessful, createProcessDataFromBatchFailure, } from "./process-data.actions";
import initialState from "./process-data.store";
export default createReducer(initialState, (builder) => {
    builder
        .addCase(setSession, (state, { payload }) => {
        state.sessionId = payload;
        if (!payload) {
            state.state = null;
            state.loading = false;
            state.uploadingTimeSeries = [];
            state.uploadingMetadata = [];
        }
    })
        .addCase(setState, (state, { payload }) => {
        state.state = payload;
    })
        .addCase(setUploadingTimeSeries, (state, { payload }) => {
        state.uploadingTimeSeries = payload;
    })
        .addCase(setUploadingMetadata, (state, { payload }) => {
        state.uploadingMetadata = payload;
    })
        .addMatcher(isAnyOf(createSession, removeSession, uploadTimeSeries, uploadMetadata, deleteTimeSeriesFile, deleteMetadataFile, createProcessDataFromBatch), (state) => {
        state.loading = true;
    })
        .addMatcher(isAnyOf(createSessionSuccessful, createSessionFailure, removeSessionSuccessful, removeSessionFailure, uploadTimeSeriesSuccessful, uploadTimeSeriesFailure, uploadMetadataSuccessful, uploadMetadataFailure, deleteTimeSeriesFileSuccessful, deleteTimeSeriesFileFailure, deleteMetadataFileSuccessful, deleteMetadataFileFailure, createProcessDataFromBatchSuccessful, createProcessDataFromBatchFailure), (state) => {
        state.loading = false;
    });
});
